const API_URL = process.env.NEXT_PUBLIC_API_URL || '/api';

function authHeaders(): HeadersInit {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export const favoriteService = {
  async getFavoriteIds(): Promise<string[]> {
    const res = await fetch(`${API_URL}/favorites/ids`, { headers: authHeaders() });
    if (!res.ok) return [];
    const data = await res.json();
    return data.data || [];
  },

  async getFavorites(): Promise<any[]> {
    const res = await fetch(`${API_URL}/favorites`, { headers: authHeaders() });
    if (!res.ok) return [];
    const data = await res.json();
    return data.data || [];
  },

  async toggleFavorite(boatId: string): Promise<boolean> {
    const res = await fetch(`${API_URL}/favorites/${boatId}`, {
      method: 'POST',
      headers: authHeaders(),
    });
    if (!res.ok) throw new Error('Toggle failed');
    const data = await res.json();
    return data.favorited;
  },
};
